import { useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getArticleWithID } from "../../api/fire-article";

export const useBlogState = () => {
  const [loading, setLoading] = useState(true);
  const [isDraft, setIsDraft] = useState(true);
  const [inputVisible, setinputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState<string[]>([]);
  const [content, setContent] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const pageType = useLocation().pathname.split("/")[1];
  let { id } = useParams() as any;

  useMemo(() => {
    if (id) {
      getArticleWithID(id).then((d) => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        setContent(d.content);
        setTitle(d.title);
        setTags(d.tags ?? []);
        setIsDraft(d.isDraft);
      });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [id]);
  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      setTags([...tags, inputValue]);
    }
    setinputVisible(false);
    setInputValue("");
  };

  const handleEditorChange = (content, editor) => {
    setContent(content);
  };

  const handleTitleChange = (content, editor) => {
    setTitle(content);
  };

  return {
    loading,
    inputVisible,
    inputValue,
    tags,
    content,
    title,
    pageType,
    id,
    handleInputConfirm,
    handleEditorChange,
    handleTitleChange,
    setInputValue,
    setinputVisible,
    isDraft,
  };
};
